export default function Staff(props) {
    function openInNewTab(url) {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className = "staff-member" style = {{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', margin: '20px'}} onClick={openInNewTab.bind(this, props.linkedin)}>
            <img src = {props.image} alt = {props.name} style = {{borderRadius: '100px', objectFit: 'cover', padding: '4px', backgroundColor: 'rgba(255, 255, 255, 0.08)', border: 'rgba(255, 255, 255, .2) 1px solid'}}></img>
            <a className = "staff-link" href = "" style = {{fontSize: '24px', transitionDuration: '.4s'}}>{props.name}</a>
            <p style = {{marginTop: '-5px'}}>{props.role}</p>
        </div>
    )
}